export class CustomerLogin {
    userName: any;
    password: any;
}